import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import UpperCard from "../Components/UpperCard";
import MidCards from "../Components/MidCards";
import SecondRightCard from "../Components/SecondRightCard";
import PendingDepositsCard from "../Components/PendingDepositsCard";
import { getDashboarddata, getBidHistory } from "../service/service";
import Pagination from "../Common/Pagination";

const Dashbaord = () => {
  const navigate = useNavigate()
  const[depositList,setDepositList]=useState([])
  const[data,setData]=useState()
  const [search, setSearch] = useState('')
  const [depositFilter, setDepositFilter] = useState('AUTO')
  const today = moment().format("YYYY-MM-DD")
  const [startDate, setStartDate] = useState(today)
  const [endDate, setEndDate] = useState(today)
  const [page, setPage] = useState(1)
  const PAGE_SIZE = 10
  
  useEffect(()=>{
    getAutoDepositHistory(today, today)
    handleGetDashboardData()
  },[])

  const handleGetDashboardData =()=>{
    getDashboarddata().then((res)=>{
      setData(res?.data?.data)
    }).catch((err)=>{
      console.log(err||"something went wrong ")
    })
  }

  const getAutoDepositHistory = (sd, ed) => {
    getBidHistory("admin-deposit-history", sd || undefined, ed || undefined).then((res) => {
      setDepositList(res?.data?.data || [])
    }).catch((err) => {
      console.log(err || "something went wrong ")
    })
  }

  const handleSearch = () => {
    setPage(1)
    getAutoDepositHistory(startDate, endDate)
  }

  const handleAll = () => {
    setStartDate('')
    setEndDate('')
    setPage(1)
    getAutoDepositHistory()
  }

  const filteredList = depositList?.filter(item => {
    const matchesSearch =
      (item?.user_id__first_name?.toLowerCase() || '').includes(search.toLowerCase()) ||
      (item?.user_id__phone_number?.toString() || '').includes(search)
    const matchesType =
      depositFilter === 'ALL' ||
      (depositFilter === 'MANUAL' && item?.is_admin === true) ||
      (depositFilter === 'AUTO' && item?.is_admin !== true)
    return matchesSearch && matchesType
  })

  const totalAmount = filteredList?.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0)
  const totalPages = Math.ceil((filteredList?.length || 0) / PAGE_SIZE)
  const pagedList = filteredList?.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

  return (
    <>
      <div className="content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-4">
                <UpperCard data={data} />
            </div>
            <div className="col-xl-8">
                <MidCards data={data} />
                <SecondRightCard data={data} />
            </div>
          </div>
          <PendingDepositsCard onDepositUpdated={() => { getAutoDepositHistory(startDate, endDate); handleGetDashboardData() }} />
          <div className="card mb-3">
            <div className="card-header d-flex justify-content-between align-items-center">
              <span><i className="fa fa-table"></i> <b>Auto Deposit History{filteredList?.length > 0 ? ` (Total: ₹${totalAmount})` : ''}</b></span>
              <div className="d-flex align-items-center flex-wrap" style={{ gap: '8px' }}>
                <input type="date" className="form-control form-control-sm" style={{ width: '145px' }} value={startDate} onChange={e => setStartDate(e.target.value)} />
                <input type="date" className="form-control form-control-sm" style={{ width: '145px' }} value={endDate} onChange={e => setEndDate(e.target.value)} />
                <button className="btn btn-danger btn-sm" onClick={handleSearch}>Go</button>
                <button className="btn btn-secondary btn-sm" onClick={handleAll}>All</button>
                <select className="form-control form-control-sm" style={{ width: '120px' }} value={depositFilter} onChange={e => setDepositFilter(e.target.value)}>
                  <option value="ALL">All</option>
                  <option value="AUTO">Auto</option>
                  <option value="MANUAL">Manual</option>
                </select>
                <input type="text" placeholder="Search..." value={search} onChange={e => { setSearch(e.target.value); setPage(1) }} style={{ width: '160px', padding: '3px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '16px' }} />
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Mobile</th>
                      <th>Amount</th>
                      <th>Type</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pagedList?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <span className="link" style={{ color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => navigate('/user-details', { state: { id: item?.user_id__id } })}>
                            {item?.user_id__first_name || "NA"}
                          </span>
                          {item?.user_id__phone_number && (
                            <a href={`https://wa.me/91${item?.user_id__phone_number}`} target="_blank" rel="noreferrer" style={{ marginLeft: '6px', color: '#25D366' }}>
                              <i className="fa fa-whatsapp" style={{ fontSize: '16px' }}></i>
                            </a>
                          )}
                        </td>
                        <td>{item?.user_id__phone_number || "NA"}</td>
                        <td>{item?.amount}</td>
                        <td><span className={`btnspan ${item?.is_admin ? 'danger' : 'success'}`}>{item?.is_admin ? 'Manual' : 'Auto'}</span></td>
                        <td>{moment(item?.created_at).format("DD-MM-YYYY, h:mm a") || "NA"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer">
              <div className="small text-muted mb-1">Showing {filteredList?.length === 0 ? 0 : (page-1)*PAGE_SIZE+1}–{Math.min(page*PAGE_SIZE, filteredList?.length || 0)} of {filteredList?.length || 0} entries</div>
              <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashbaord;
